import { Header } from './Header'

export function AppLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
    </>
  )
}
